<template>
    <div class="fade-in">
        <div
            v-for="(item, index) in educations"
            :key="item.uuid || index"
            class="border border-light rounded mb-3 overflow-hidden"
        >
            <div class="bg-light px-3 py-2">
                <div class="pr-3">
                    <h6 class="font-weight-bold mb-1">{{ item.name || '--' }}</h6>
                    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                        <small class="text-muted">{{ item.institute || '--' }}</small>
                        <small class="text-muted mt-1 mt-sm-0">{{ item.startDate || '--' }} {{ item.endDate ? '- ' + item.endDate : '--' }}</small>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Field</small>
                        <div class="font-weight-bold">{{ item.field || '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Location</small>
                        <div class="font-weight-bold">{{ item.location || '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Grade</small>
                        <div class="font-weight-bold">{{ item.grade || '--' }}</div>
                    </div>
                    <div class="col-md-12">
                        <small class="text-muted d-block">Description</small>
                        <div>{{ item.description || '--' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <b-alert
            v-if="!educations || educations.length == 0"
            show
            variant="warning"
            class="text-center"
        >
            <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
        </b-alert>
    </div>
</template>
<script>
export default {
    props: {
        educations: {
            type: Array,
            required: true,
        },
    },
}
</script>
